import React, { useState } from 'react';
import { Box, Button, Popover } from '@mui/material';
import { TreeItem, SimpleTreeView } from '@mui/x-tree-view';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const subjectList = {
  "Mathematics": ["Math 4", "Math 5", "Math 6", "Math 7", "Math 8", "Math 9", "Math 10", "Math 11", "Advanced Function", "Calculus & Vector", "Data Management", "Contest", "AP Calculus", "Linear Algebra","IB Math"],
  "Science": ["Science 7", "Science 8", "Science 9", "Science 10", "Biology 11", "Biology 12", "Biology AP", "Chemistry 11", "Chemistry 12", "Chemistry AP", "Physics 11", "Physics 12", "Physics AP"],
  "English": ["English", "ESL"],
  "Computer Science": ["Python", "Java", "Coding Lab", "AP Computer Science"],
  "Other":["Admin"]
};

const SingleSelectTreeView = ({ disabled = false, selectedSubject, onSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleItemSelect = (itemId) => {
    const parts = itemId.split('-');
    
    // Check if it's a leaf node (subject), not a parent category
    if (parts.length === 3) {
      const [categoryIndex, subjectIndex] = parts.slice(1);
      const subject = subjectList[Object.keys(subjectList)[categoryIndex]][subjectIndex];
      onSelect(subject);
      handleClose();  // Close the dropdown after selecting a subject
    }
  };

  return (
    <Box sx={{ minWidth: 250 }}>
      <Button
        variant="outlined"
        onClick={handleClick}
        disabled={disabled}
        fullWidth
        sx={{
          justifyContent: 'space-between',
          color: disabled ? '#9e9e9e' : selectedSubject ? 'black' : '#9e9e9e', // Text color based on disabled state
          backgroundColor: 'white', // Background color based on disabled state
          padding: '10px 15px',
          borderColor: disabled ? '#e0e0e0' : '#b0b0b0', // Border color based on disabled state
        }}
        endIcon={<ArrowDropDownIcon />} // Adds dropdown arrow icon
      >
        {selectedSubject || 'Select Subject*'}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ maxHeight: 300, minWidth: 250, overflowY: 'auto' }}>
          <SimpleTreeView
            defaultCollapseIcon={<ExpandMoreIcon />}
            defaultExpandIcon={<ChevronRightIcon />}
            onItemClick={(event, itemId) => handleItemSelect(itemId)}
          >
            {Object.keys(subjectList).map((category, index) => (
              <TreeItem itemId={`category-${index}`} label={category} key={category}>
                {subjectList[category].map((subject, subIndex) => (
                  <TreeItem itemId={`subject-${index}-${subIndex}`} label={subject} key={subject} />
                ))}
              </TreeItem>
            ))}
          </SimpleTreeView>
        </Box>
      </Popover>
    </Box>
  );
};

export default SingleSelectTreeView;
